module.exports = __webpack_public_path__ + "img/main.21d47e03.jpg";